module.exports = "/assets/data/1218e5d2ce3b885cb5bf473ad3d5f0e5-EN2.data.json";